<script setup lang="ts">
  import { ref } from 'vue';
  import { DatePicker, IconImage } from '@/shared/ui';
  import { formatDateToPtBR } from '@/shared/lib';
  import CalendarIcon from '@/shared/assets/icons/CalendarIcon.svg';

  defineProps<{
    modelValue: Date | null;
    testid: string;
    labelledby: string;
  }>();

  const emit = defineEmits<{
    'update:modelValue': [date: Date | null];
  }>();

  const isOpen = ref(false);
</script>

<template>
  <button
    type="button"
    :data-testid="testid"
    :aria-labelledby="labelledby"
    aria-haspopup="dialog"
    :aria-expanded="isOpen"
    class="flex w-full items-center gap-2 rounded-lg border border-[var(--color-border-color)] bg-white-01 px-4 py-2.5 text-sm whitespace-nowrap focus:outline-none"
    @click="isOpen = true"
  >
    <IconImage
      :src="CalendarIcon"
      alt="Calendário"
      class="h-5 w-5 shrink-0"
    />
    <span :class="modelValue ? 'text-gray-07' : 'text-gray-03'">
      {{ modelValue ? formatDateToPtBR(modelValue) : 'Selecione uma data' }}
    </span>
  </button>
  <DatePicker
    :selected-date="modelValue"
    :is-open="isOpen"
    @update:selected-date="emit('update:modelValue', $event)"
    @update:is-open="isOpen = $event"
  />
</template>
